import { atom, useSetAtom } from "jotai";
import { type ReactNode, useEffect } from "react";

export interface NavGroup {
    key: string;
    header?: ReactNode;
    icon?: ReactNode;
    items?: NavItem[];
    detailsPath?: string;
}

export interface NavItem {
    path: string;
    label: string;
    roles?: string[];
    icon?: ReactNode;
    pendingCount?: string | number;
}

export const dashboardLayoutAtom = atom<{
    sbarExpanded?: boolean;
    pageTitle?: string;
    isPrinting?: boolean;
}>({});

// Store for collapsed sections - all sections collapsed by default
export const collapsedSectionsAtom = atom<Set<string>>(
    new Set<string>([
        "orderLifecycle",
        "soilTesting",
        "marketplace",
        "equipment-rental",
        "inventory",
        "insurance",
        "userMgmt",
        "utils",
        "appContent",
    ]),
);

export const usePageTitle = (pageTitle: string) => {
    const setDashboardLayout = useSetAtom(dashboardLayoutAtom);

    useEffect(() => {
        setDashboardLayout(prev => ({
            ...prev,
            pageTitle,
        }));
    }, [pageTitle]);
};
